import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import './Navbar.css';
import { NotificationService } from "../../service/notifications.service";
import NotificationBadge from "../notifications/NotificationBadge";
import Cookies from "js-cookie";
import { isUserAuthenticated , hideOptions } from "../../utils/config";
  
///import {browserhistory} from 'react-router'

function Navbar(props: any) {


  const navigate = useNavigate();
  const [notificationCount, setNotificationCount] = useState(0);




  const doLogout = () => {

    navigate("/", { replace: true });
    // browserhistory.replace("../")
    // props.navigation.reset(0)
  }

   /*var counter = 1 ;

  const countDown = ()=> {
    
    counter = counter +1;
    if (counter == 6) {
      
      counter = 1
      fetchCount()
    }
    // let count =  counter;
     //setNotificationCount(count)
  }
 


  const fetchCount = ()=> {
    notificationService.getNotificationCount().then(data => {
      const res = data;

      //alert("count "+ res.entApprovalNotificationCnt);
      console.log('countttttt -- ', res.entApprovalNotificationCnt)
      setNotificationCount(res.entApprovalNotificationCnt)
   

  });
  }

  
  let loaddatacalled = false;
  useEffect(() => {

    if (!loaddatacalled) {

        setInterval(countDown, 1000);
      loaddatacalled = true;
      
    }
  }, []); */

  const isAuthenticated = isUserAuthenticated();
  const [hideNavigation, setHideNavigation] = useState(true);

  let loaddatacalled = false;
  useEffect(() => {

    if (!loaddatacalled) {

      if (isAuthenticated) {  
          setHideNavigation(hideOptions())
      }
      loaddatacalled = true;
      
    }
  }, [isAuthenticated]);



  return (
    <div className="App">
      <nav className="navbar navbar-expand-lg navbar-light bg-light p-0 pl-5 pr-5 mt-2">
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarText"
          aria-controls="navbarText"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarText">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item dropdown pr-2" hidden = {hideNavigation} >
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Category Management
              </a>
              <div
                className="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink">
                <Link to="categories" onClick={() => props.setBreadCrumb("Category Management / Main Categories")}>
                  <a className="dropdown-item" href="#">Main Categories</a>
                </Link>
                <Link to="sub_categories" onClick={() => props.setBreadCrumb("Category Management / Sub Categories")}>
                  <a className="dropdown-item" href="#">Sub Categories</a>
                </Link>
                <Link to="brands" onClick={() => props.setBreadCrumb("Category Management / Brands")}>
                  <a className="dropdown-item" href="#">Brands</a>
                </Link>

              </div>
            </li>
            <li className="nav-item dropdown pr-2" hidden = {hideNavigation}>
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Product Management
              </a>
              <div
                className="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <Link to="products" onClick={() => props.setBreadCrumb("Product Management / Products")}>
                  <a className="dropdown-item" href="#">Products</a>
                </Link>

                <Link to="finishes" onClick={() => props.setBreadCrumb("Product Management / Finishes")}>
                  <a className="dropdown-item" href="#">Finishes</a>
                </Link>
                <Link to="sizes" onClick={() => props.setBreadCrumb("Product Management / Sizes")}>
                  <a className="dropdown-item" href="#">Sizes</a>
                </Link>
                <Link to="downloadproducttabledata" onClick={() => props.setBreadCrumb("Product Management / Download Products")}>
                  <a className="dropdown-item" href="#">Download Products</a>
                </Link>
              </div>
            </li>
            <li className="nav-item dropdown pr-2 " hidden = {hideNavigation} >
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                User Management
              </a>
              <div
                className="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <Link to="enterprise" onClick={() => props.setBreadCrumb("User Management / Enterprise Users")}>
                  <a className="dropdown-item" href="#">Enterprise Users</a>
                </Link>

                <Link to="retail" onClick={() => props.setBreadCrumb("User Management / Retail Users")}>
                  <a className="dropdown-item" href="#">Retail Users</a>
                </Link>

                <Link to="salesrep" onClick={() => props.setBreadCrumb("User Management / Sales Representatives")}>
                  <a className="dropdown-item" href="#">Sales Representatives</a>
                </Link>

                <Link hidden to="dealers" onClick={() => props.setBreadCrumb("User Management / Dealers N/W")}>
                  <a className="dropdown-item" href="#">Dealers N/W</a>
                </Link>
              </div>
            </li>
            <li className="nav-item dropdown pr-2"  >
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Orders & Quotes
              </a>
              <div
                className="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <Link to="orders" onClick={() => props.setBreadCrumb("Orders / Manage")}>
                  <a className="dropdown-item" href="#">Manage Orders</a>
                </Link>

                <Link to="quotations" onClick={() => props.setBreadCrumb("Quotations / Manage")}>
                  <a className="dropdown-item" href="#">Manage Quotations</a>
                </Link>
                {/*}
                <Link to="notifications">
                <a className="dropdown-item" href="#">Push Notifications</a>
                </Link>

                <Link to="downloads">
                <a className="dropdown-item" href="#">Downloads</a>
                </Link>

                <Link to="enquiry">
                <a className="dropdown-item" href="#">Enquiry Orders</a>
                </Link>
                */}
              </div>
            </li>
            <li className="nav-item dropdown pr-2" hidden = {hideNavigation} >
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Uploads
              </a>
              <div
                className="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <Link to="batchprocessing" onClick={() => props.setBreadCrumb("Uploads / Bulk Upload")}>
                  <a className="dropdown-item" href="#">Bulk Upload</a>
                </Link>
                <Link to="stockupload" onClick={() => props.setBreadCrumb("Uploads / Stock Upload")}>
                  <a className="dropdown-item" href="#" hidden >Stock Upload</a>
                </Link>
                <Link to="catalogues" onClick={() => props.setBreadCrumb("Uploads / Catalogs")}>
                  <a className="dropdown-item" href="#">Catalogs</a>
                </Link>
                {/*}
                <Link to="notifications">
                <a className="dropdown-item" href="#">Push Notifications</a>
                </Link>

                <Link to="downloads">
                <a className="dropdown-item" href="#">Downloads</a>
                </Link>

                <Link to="enquiry">
                <a className="dropdown-item" href="#">Enquiry Orders</a>
                </Link>
                */}
              </div>
            </li>


            <li className="nav-item dropdown pr-2" hidden = {hideNavigation} >
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Feedback
              </a>
              <div
                className="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <Link to="batchprocessing" onClick={() => props.setBreadCrumb("Customer")}>
                  <a className="dropdown-item" href="#">Customer</a>
                </Link>
                <Link to="salesfeedbacklist" onClick={() => props.setBreadCrumb("Sales Rep")}>
                  <a className="dropdown-item" href="#"  >Sales Rep</a>
                </Link>
               
                {/*}
                <Link to="notifications">
                <a className="dropdown-item" href="#">Push Notifications</a>
                </Link>

                <Link to="downloads">
                <a className="dropdown-item" href="#">Downloads</a>
                </Link>

                <Link to="enquiry">
                <a className="dropdown-item" href="#">Enquiry Orders</a>
                </Link>
                */}
              </div>
            </li>
 




            <div  className="nav-link  notification">

              {/*<span className="badge">{ notificationCount +"" }</span> */}

                <NotificationBadge  count={notificationCount} ></NotificationBadge>
              <Link to="newnotifications" onClick = { () => 
                {
                 // setNotificationCount(0)
                 
                  props.setBreadCrumb("Notificaions")
                }
                 }
                >
                <a href="#">Notifications</a>
              </Link>

            </div>


          </ul>
          <a href="#" className="navbar-text" data-toggle="modal" data-target="#myModal" hidden >Logout</a>
        </div>
      </nav>
      <div className="modal" id="myModal">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Logout Page</h6>
              <button type="button" className="close" data-dismiss="modal">&times;</button>
            </div>
            <div className="modal-body text-left">
              Are you sure do you want to logout?
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-sm" data-dismiss="modal">No</button>
              <button type="button" className="btn btn-sm btn-success" data-dismiss="modal" onClick={doLogout} >Yes</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
